var _rect, _defs, _defs2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#001220"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 378.6C-70.5 371.1 -140.9 363.7 -189.3 327.9C-237.7 292 -264 227.9 -291.9 168.5C-319.7 109.1 -349.2 54.6 -378.6 0L0 0Z",
    fill: "#6A64F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -378.6C58.3 -355.6 116.6 -332.7 175.5 -304C234.4 -275.3 293.9 -240.9 327.9 -189.3C361.8 -137.7 370.2 -68.8 378.6 0L0 0Z",
    fill: "#6A64F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgForm);
export default __webpack_public_path__ + "static/media/bg-form.214b1e734d7fdefbfdfe8249fbc39428.svg";
export { ForwardRef as ReactComponent };